
import card1 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card4.webp";
import card2 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card5.webp";
import card3 from "../../../assets/img/projects/Galerie_Fanny/Galerie_Fanny-Card6.webp";

import { useScrollAnim } from "../../hook/useScrollAnim";

export default function Card() {
  const containerRef = useScrollAnim({
    selector: "div, img",
    threshold: 0.3,
    once: true,
  });
  return (
    <>
      <div className="GaFa-cards down" ref={containerRef}>
        <div>
          <img src={card1} alt="" />
        </div>
        <div>
          <img src={card2} alt="" />
        </div>
        <div>
          <img src={card3} alt="" />
        </div>
      </div>
    </>
  );
}
